@if (componentAvailableSub.getValue() === true) {
  @if (errorOccured === false) {
    @if (isloaderVisible) {
      <div style="height: 100px" class="d-flex align-items-center justify-content-center">
        <div class="loading"></div>
      </div>
    }
    <div class="container-fluid px-0">
      @for (newsItem of newsData; track newsItem; let first = $first; let last = $last) {
        <div class="row" [ngClass]="{ 'border-top': !first }">
          <div class="col">
            <app-slipcase-item-content
              [showItemHostname]="showItemHostname"
              [showPublishDate]="showPublishDate"
              [showTopics]="showTopics"
              [newsItem]="newsItem"
              [isCompact]="true"
              [isMostPopular]="useInputFeed"></app-slipcase-item-content>
          </div>
        </div>
      }
    </div>
  }
  @if (errorOccured === true) {
    <div class="container-fluid px-0 pt-4">
      <div class="row">
        <div class="col">
          <wre-not-available
            serviceName="Slipcase"
            [errorOccured]="errorOccured"></wre-not-available>
        </div>
      </div>
    </div>
  }
}
